import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=1c254236&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"
import style0 from "./Nav.vue?vue&type=style&index=0&id=1c254236&prod&scoped=true&lang=less&"
import style1 from "./assets/tailwind.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c254236",
  null
  
)

export default component.exports